export default {
  init() {
    $(".proto-scroll").each((i, item) => {
      let reqAnimationId, type;

      let imagePos = 0;
      let playing = false;

      const wrapperEl = $(item);
      const screenEl = wrapperEl.find(".proto-scroll__screen");
      const imageEl = wrapperEl.find(".proto-scroll__img")[0];

      function smoothAnimation() {
        if (!playing) {
          return;
        }
        const offset = 5;

        const screenHeight = screenEl.height();

        if ("top" == type) {
          imagePos -= offset;
        }
        if ("bottom" == type) {
          imagePos += offset;
        }

        if (imagePos <= 0) {
          imagePos = 0;
        }

        let maxScroll = imageEl.height - screenHeight;

        if (imagePos >= maxScroll) {
          imagePos = maxScroll;
        }

        imageEl.style.transform = `translateY(-${imagePos}px)`;

        // animtion
        reqAnimationId = requestAnimationFrame(smoothAnimation);
      }

      // to start
      function startImage() {
        playing = true;
        reqAnimationId = requestAnimationFrame(smoothAnimation);
      }

      // to end
      function stopImage() {
        playing = false;
        cancelAnimationFrame(reqAnimationId);
      }

      wrapperEl.find(".proto-scroll__part--top").on("mouseenter", () => {
        type = "top";
        startImage();
      });

      wrapperEl.find(".proto-scroll__part--bottom").on("mouseenter", () => {
        type = "bottom";
        startImage();
      });

      wrapperEl.find(".proto-scroll__part").on("mouseleave", () => {
        stopImage();
      });
    });
  },
};
